import {cva} from 'class-variance-authority';

export const checkboxVariants = cva(
  'peer h-6 w-6 rounded-full shrink-0 border border-gray-800' +
    ' focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2' +
    ' disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        default:
          'data-[state=checked]:bg-mint-500 data-[state=checked]:border-mint-500 data-[state=checked]:text-white',
        rejected:
          'data-[state=checked]:bg-red-500 data-[state=checked]:border-red-500 data-[state=checked]:text-white',
      },
      touchOptimized: {
        true: 'relative size-8 after:absolute after:-inset-1.5 [&_svg]:size-5',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
